// Variaveis de ambiente

// URL orquestrador
const urlDefault = 'https://onrhml.forluz.org.br:4000/';
export const baseURL = process.env.REACT_APP_NODE_RED_URL
  ? process.env.REACT_APP_NODE_RED_URL
  : urlDefault;

// ADM
const admDefault = '10.2.103.139';
export const baseADM = process.env.REACT_APP_ADM_URL
  ? process.env.REACT_APP_ADM_URL
  : admDefault;

// CAPTCHA
const recaptchaDefault = '';
export const baseCAPTCHA = process.env.REACT_APP_REQUIRED_RECAPTCHA
  ? process.env.REACT_APP_REQUIRED_RECAPTCHA
  : recaptchaDefault;

// CAPTCHA
const CAPTCHAKEYDefault = '6LctdEAlAAAAAHF5QB5yhH0QiaANCcAEMdN9Ev1W';
export const baseCAPTCHAKEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  ? process.env.REACT_APP_RECAPTCHA_SITE_KEY
  : CAPTCHAKEYDefault;
